import { render, staticRenderFns } from "./addPackagingTransfer.vue?vue&type=template&id=33b0986c"
import script from "./addPackagingTransfer.vue?vue&type=script&lang=js"
export * from "./addPackagingTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports